import React from 'react';

const ButtonSearch = () => {
    return (
        <button type="submit" className="btn btn-sm btn-link border-0 p-0 min-w-auto text-uppercase">Cauta</button>
    );
};

export default ButtonSearch;
